import { isAxiosError } from 'axios';
import { createApiError } from '@/lib/create-api-error';
import { type CustomApiError, NetworkError } from './custom-api-errors';

type Success<T> = {
  data: T;
  error: null;
};

type Failure<E> = {
  data: null;
  error: E;
};

export type Result<T, E = CustomApiError | Error> = Success<T> | Failure<E>;

export async function tryCatch<T, E = CustomApiError | NetworkError | Error>(
  promise: Promise<T>,
): Promise<Result<T, E>> {
  try {
    const data = await promise;

    return { data, error: null };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.code === 'ERR_NETWORK') {
        return { data: null, error: new NetworkError('ERR_NETWORK') as E };
      }

      if (error.response?.data) {
        return { data: null, error: createApiError(error.response.data) as E };
      }
    }

    return { data: null, error: error as E };
  }
}
